// --- CONSTANTS ---
export interface BreadcrumbItem {
  label: string;
  link: string;
}

export interface BreadcrumbFlows {
    [key: string]: BreadcrumbItem[];
}

export interface BreadcrumbData {
    [key: string]: BreadcrumbFlows;
}

export const navigationBreadcrumbs: BreadcrumbData = {
  vendorManagement: {
    quarterlyFeedback: [
      { label: 'Vendor Management', link: '/vendor-management' },
      { label: 'Quarterly Feedback', link: '' },
    ],
  },

  opsVendorManagement: {
    opsContractorProfile: [
      { label: 'Vendor Management', link: '/ops-vendor-management' },
      { label: 'Contractor Profile', link: '' },
    ],
    quarterlyFeedback: [
      { label: 'Vendor Management', link: '/ops-vendor-management' },
      { label: 'Quarterly Feedback', link: '' },
    ],
  },

  vendorFlowDashboard: { },

  teamMangement: { },

  assetManagement: {
    inventoryDetails: [
      { label: 'Ops Dashboard', link: '/asset-management' },
      { label: 'Accessories Management', link: '' },
    ],
    inventoryOrderDetails: [
      { label: 'Ops Dashboard', link: '/asset-management' },
      { label: 'Orders', link: '' },
    ],
    damageAnalyticsDetails: [
      { label: 'Ops Dashboard', link: '/asset-management' },
      { label: 'Damage Analytics', link: '' },
    ],
    onboardingDetails: [
      { label: 'Ops Dashboard', link: '/asset-management' },
      { label: 'Upcoming Onboarding', link: '' },
    ],
    offboardingDetails: [
      { label: 'Ops Dashboard', link: '/asset-management' },
      { label: 'Upcoming Off-boarding', link: '' },
    ],
    vendorStatsDetails: [
      { label: 'Ops Dashboard', link: '/asset-management' },
      { label: 'Vendor Stats', link: '' },
    ],
    assetAllocatedDetails: [
      { label: 'Ops Dashboard', link: '/asset-management' },
      { label: 'Assets Allocated', link: '' },
    ],
    myRequestDetails: [
      { label: 'Ops Dashboard', link: '/asset-management' },
      { label: 'My Requests', link: '' },
    ],
  },

};


// --- SERVICE CLASS ---
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {

  getBreadcrumbs(useCaseKey: string, flowKey: string): BreadcrumbItem[] {
    const useCaseData = navigationBreadcrumbs[useCaseKey];

    if (useCaseData && useCaseData[flowKey]) {
      return useCaseData[flowKey];
    }

    return [];
  }
}